require('./bootstrap');

jQuery(function($) {
    $('body').on('click', 'a[data-order-id]', (e) => {
        e.preventDefault()
        $('#order-' + $(e.currentTarget).data('order-id')).toggle()
    })
})
